import { render, staticRenderFns } from "./ReviewSession.vue?vue&type=template&id=6d4c9a4f&lang=pug&"
import script from "./ReviewSession.vue?vue&type=script&lang=js&"
export * from "./ReviewSession.vue?vue&type=script&lang=js&"
import style0 from "./ReviewSession.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports